import { StyleSheet } from "react-native";
import {
  ListItemContainer,
  ListItemValue,
  FlatListItemSeparator,
  IconButton,
  HStack,
  Switch,
} from "@smartrent/ui";
import { Close } from "@smartrent/icons";
import { startCase } from "lodash-es";

interface CMWFlagListItemProps {
  flagName: string;
  enabled: boolean;
  onToggle: () => void;
  onRemove: () => void;
  showSeparator?: boolean;
  switchName?: string;
}

export function CMWFlagListItem({
  flagName,
  enabled,
  onToggle,
  onRemove,
  showSeparator = false,
  switchName,
}: CMWFlagListItemProps) {
  return (
    <>
      <ListItemContainer>
        <HStack style={styles.listItemContent} spacing={8} align="center">
          <ListItemValue>{startCase(flagName)}</ListItemValue>
          <Switch
            name={switchName || `toggle-${flagName}`}
            onValueChange={onToggle}
            value={enabled}
          />
          <IconButton
            icon={Close}
            size="x-small"
            variation="plain"
            color="destructive"
            onPress={onRemove}
            contentStyle={styles.removeButton}
          />
        </HStack>
      </ListItemContainer>
      {showSeparator && <FlatListItemSeparator style={styles.separator} />}
    </>
  );
}

const styles = StyleSheet.create({
  listItemContent: {
    flex: 1,
    alignItems: "center",
    justifyContent: "space-between",
  },
  separator: {
    marginVertical: 0,
  },
  removeButton: {
    paddingHorizontal: 0,
  },
});
